import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { enqueueSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import CustomAlertList from '../components/CustomAlertList';
import CustomAlertCRU from '../components/CustomAlertCRU';
import { deleteCustomAlertApi, getCustomAlertApi } from '../apiService';
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../shared_elements';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { globalDeleteService, globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { ShowAttachments } from '../../../shared_elements/components';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import { trackActivity } from '../../../utils/mixpanel';
import { RoleBaseAccess } from '../../../hoc';
import { PermissionWrapper } from '../../../wrappers';
import { getStorage } from '../../../shared_elements/actionCreators';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const CustomAlertHD = ({ onRequestSort, sortConfig, item, toggleBulkOps, bulk }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Custom Alerts`, page_type: page_type, })
    }
    return (
        <TableRow>
            <TableCell className="table-actions-header" sx={{ whiteSpace: "nowrap", minWidth: '140px' }}>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "custom_alert", operationType: ['D'] }}>
                    <Checkbox size='small' sx={{ cursor: 'pointer' }} onChange={(e) => toggleBulkOps(e.target.checked, "bulk", item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} /></PermissionWrapper> Action(s)
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "name"} direction={sortConfig?.field === "name" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("name"); handleItemClicked(`Table Sorting: Name`) }}>Name</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '170px', whiteSpace: 'nowrap'}}>
                <TableSortLabel active={sortConfig?.field === "frequency_to_notify"} direction={sortConfig?.field === "frequency_to_notify" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("frequency_to_notify"); handleItemClicked(`Table Sorting: Notify Days`) }}>Notify Days</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '110px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "start_date"} direction={sortConfig?.field === "start_date" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("start_date"); handleItemClicked(`Table Sorting: Start Date`) }}>Start Date</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "end_date"} direction={sortConfig?.field === "end_date" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("end_date"); handleItemClicked(`Table Sorting: End Date`) }}>End Date</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "status"} direction={sortConfig?.field === "status" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("status"); handleItemClicked(`Table Sorting: Status`) }}>Status</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '200px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "sparta_user_email"} direction={sortConfig?.field === "sparta_user_email" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("sparta_user_email"); handleItemClicked(`Table Sorting: SPARTA Users`) }}>SPARTA Users</TableSortLabel>
            </TableCell>
            <TableCell sx={{ minWidth: '200px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "non_sparta_user_email"} direction={sortConfig?.field === "non_sparta_user_email" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("non_sparta_user_email"); handleItemClicked(`Table Sorting: Non SPARTA Users`) }}>Non SPARTA Users</TableSortLabel>
            </TableCell>
             <TableCell sx={{ minWidth: '100px', whiteSpace: 'nowrap' }}>
                <TableSortLabel active={sortConfig?.field === "description"} direction={sortConfig?.field === "description" ? sortConfig.direction : "asc"} onClick={() => { createSortHandler("description"); handleItemClicked(`Table Sorting: Description`) }}>Description</TableSortLabel>
                       </TableCell>
        </TableRow>
    );
}

const CustomAlerts = ({ setActionBar }) => {
    const dispatch = useDispatch()
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const [addEditCustomAlert, setAddEditCustomAlert] = useState({ mode: "", modal: false, data: null });
    const [customAlertInfo, setCustomAlertInfo] = useState({ list: [], pagination: null });
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [loading, setLoading] = useState(false);
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: "", type: "" });
    const [sortConfig, setSortConfig] = useState({ field: "", direction: "" });
    const [deleteCustomAlert, setDeleteCustomAlert] = useState({ modal: false, data: null });
    const [uploadFile, setUploadfile] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [uploadFileProgressData, setUploadFileProgressData] = useState({});
    const [uploadFileStatus, setUploadFileStatus] = useState({ modal: false, data: null, mode: "" });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });


    useEffect(() => {
        getCustomAlertNotification("skeletonLoader", { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Custom Alerts' })
        const uploadedFileData = getApiResponse("custom_alert", slug);
        setUploadFileProgressData({ uploadedFileData });
    }, []);

    useEffect(() => {
        if (!setActionBar) return;
        setActionBar(
            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px' }}>
                <li className='lease-mobile-button revision-history'>
                    <ModuleWiseRevisionHistory ViewGlobalHistory={() => { setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } }); handleItemClicked('Global Revision HistoryIcon'); }} />
                </li>
                {bulk?.type && bulk?.ids?.length ? <>
                    <li className='lease-mobile-button'>
                        <Button size="small" variant="outlined" color="primary" onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button'); }}>Cancel</Button>
                    </li>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "custom_alert", operationType: ['D'] }}>
                        <li className='lease-mobile-button'>
                            <Button variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057" }} onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button'); }}>{`Delete (${bulk?.ids?.length})`}</Button>
                        </li>
                    </PermissionWrapper>
                </> : null}
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "custom_alert", operationType: ['C'] }}>
                    <li className='lease-mobile-button'>
                        <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon'  color='primary' variant='contained' size='small' onClick={() => { setAddEditCustomAlert({ modal: true, mode: 'add', data: { 'sparta_users': [], 'non_sparta_users': [] } }); handleItemClicked('Add Item Button'); }}>Add Custom Alert</Button>
                    </li>
                </PermissionWrapper>
            </ul>
        );
    }, [bulk, setActionBar]);

    const getCustomAlertNotification = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getCustomAlertApi(params, query), {})
            .then(response => {
                if (checkApiStatus(response)) {
                    setCustomAlertInfo(response?.data?.data || { list: [], pagination: null });
                }
                loaderType === "skeletonLoader" ? setSkeletonLoader(false) : setLoading(false);
            })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "custom_alert" }))
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === "bulk") {
            setBulk({ ...bulk, type: "bulk", ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const onRequestSort = (event, property) => {
        const isAscending = sortConfig.field === property && sortConfig.direction === "asc";
        const newDirection = isAscending ? "desc" : "asc";
        setSortConfig({ field: property, direction: newDirection });
        getCustomAlertNotification('fetch', {
            page: customAlertInfo?.pagination?.current_page || 1,
            per_page: customAlertInfo?.pagination?.per_page || 10,
            sort: newDirection,
            sort_by: property,
        });
    };

    const handelDeleteCustomAlert = async () => {
        setLoading(true);
        const idsToDelete = deleteCustomAlert?.modal && deleteCustomAlert?.data?.id ? [deleteCustomAlert?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        try {
            const response = await globalDeleteService(deleteCustomAlertApi(leaseSlug), { ids: idsToDelete });
            if (checkApiStatus(response)) {
                enqueueSnackbar("Custom alert deleted successfully", {
                    variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }
                });
                trackActivity('Item Deleted', { page_title: `Delete Custom Alert`, success_msg: 'Deleted successfully', item_ids: deleteCustomAlert?.data || bulk?.ids, response: 'Deleted successfully' })
                setDeleteCustomAlert({ modal: false, data: null });
                setBulk({ modal: false, ids: [], type: "", title: "" });
                getCustomAlertNotification("fetch", { per_page: customAlertInfo?.pagination?.per_page || 50 });
            } else {
                trackActivity('Item Deleted', { page_title: `Delete Custom Alert`, error_msg: response?.data?.message || 'Delete failed', item_ids: deleteCustomAlert?.data || bulk?.ids, response: response?.data })
                enqueueSnackbar(response?.data?.message || "Delete failed", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
            }
        } catch (error) {
            trackActivity('Item Deleted', { page_title: `Delete Custom Alert`, error_msg: 'Delete failed', item_ids: deleteCustomAlert?.data || bulk?.ids, response: 'Delete failed' })
            enqueueSnackbar("Delete failed", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
        }
    };

    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "custom_alert",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getCustomAlertNotification("", { per_page: customAlertInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({})
    };


    const handelAttchments = (attachslug) => {
        setUploadfile({
            ...uploadFile, data: { ...uploadFile.data, attachments: uploadFile.data.attachments.filter(item => item.slug !== attachslug) }
        });
        getCustomAlertNotification("", { per_page: customAlertInfo?.pagination?.per_page || 50 });
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Custom Alerts`, page_type: page_type, })
    }

    return (
        <>
            <Paper elevation={0}>
                <div style={{ padding: '5px 0px' }}>
                    {
                        skeletonLoader ? <STableLoader count={4} rowCount={11} /> :
                            <>
                                <Paper className='notification-container' sx={{ overflow: 'auto', boxSizing: 'border-box', ...(customAlertInfo?.list?.length > 0
                                    ? { height: 'calc(100vh - 290px) !important' }
                                    : { height: 'auto !important', maxHeight: 'calc(100vh - 290px) !important' }
                                ) }}>
                                    <Table  className='mui-table-format' stickyHeader>
                                        <TableHead>
                                            <CustomAlertHD
                                                onRequestSort={onRequestSort}
                                                sortConfig={sortConfig}
                                                item={customAlertInfo?.list}
                                                bulk={bulk}
                                                toggleBulkOps={toggleBulkOps}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {
                                                customAlertInfo?.list?.length > 0 && customAlertInfo?.list?.map((item, index) => {
                                                    return (
                                                        <CustomAlertList
                                                            toggleBulkOps={toggleBulkOps}
                                                            bulk={bulk}
                                                            key={index}
                                                            item={item}
                                                            onView={() => setAddEditCustomAlert({ modal: true, mode: "view", data: item })}
                                                            onEdit={() => setAddEditCustomAlert({ modal: true, mode: 'edit', data: item, })}
                                                            onDelete={() => {
                                                                setDeleteCustomAlert({ modal: true, data: item });
                                                                setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                            }}
                                                            slug={slug?.slug}
                                                            onOpenAttachments={() => setUploadfile({ modal: true, data: addEditCustomAlert?.data, mode: 'view' })}
                                                            uploadFileProgressData={uploadFileProgressData}
                                                            viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                            viewFile={() => setUploadfile({ modal: true, mode: 'file', data: item })}
                                                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                        />
                                                    )
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </Paper>
                                {customAlertInfo?.list?.length === 0 && <NoRecordFound />}
                                <Paper>
                                    <Pagination
                                        pagination={customAlertInfo?.pagination}
                                        onRowsPerPageChange={(e) => getCustomAlertNotification("", { page: 1, per_page: e.target.value, ...(sortConfig?.field && { sort: sortConfig.direction, sort_by: sortConfig.field }) })}
                                        onPageChange={(event, newPage) => getCustomAlertNotification("", { page: newPage + 1, per_page: customAlertInfo?.pagination?.per_page, ...(sortConfig?.field && { sort: sortConfig.direction, sort_by: sortConfig.field }) })}
                                    />
                                </Paper>
                            </>
                    }
                </div>
            </Paper>
            {loading ? <PageLoader /> : null}

            {addEditCustomAlert.mode ?
                <CustomAlertCRU
                    modeType={addEditCustomAlert?.mode}
                    addEditCustomAlert={addEditCustomAlert}
                    onToggleModal={() => setAddEditCustomAlert({ modal: false, data: null })}
                    params={params}
                    getResponseBack={() => {getCustomAlertNotification('pageLoader', {
                        page: customAlertInfo?.pagination?.page || 1,
                        per_page: customAlertInfo?.pagination?.per_page || 10
                    }); setBulk({modal: false, ids: [], type: '', title: ''});}}
                    fileUpload={handleUpload}
                    onOpenAttachments={() => setUploadfile({ modal: true, data: addEditCustomAlert?.data, mode: 'view' })}
                /> : null}

            {deleteCustomAlert?.modal ?
                <DeletePopUp
                    modal={deleteCustomAlert.modal}
                    title="Delete Custom Alert"
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        setDeleteCustomAlert({ modal: false, data: null });
                        setBulk({ modal: false, ids: [], title: '', type: '' })
                    }}
                    onDeleteRecords={() => handelDeleteCustomAlert()} /> : null
            }

            {
                bulk.modal ? <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.ids?.length === (customAlertInfo?.list?.length || 0) ? "All Custom Alerts" : "Selected Custom Alerts"}`}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [] })}
                    onDeleteRecords={() => handelDeleteCustomAlert()}
                /> : null
            }

            {
                uploadFile.modal ? <ShowAttachments
                    url="delete-attachment"
                    moduleName="Custom Alert Notification"
                    attachmentsData={uploadFile}
                    getResponseBack={handelAttchments}
                    toggleModalFn={() => setUploadfile({ modal: false, data: null, mode: '' })}
                    onViewDisabled={addEditCustomAlert?.mode === 'view' || uploadFile?.mode === 'view'}
                    permissionKey='custom_alert'
                /> : null
            }

            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={() => setSlug({})}
            />

            {
                revisionHistory.modal &&
                <RevisionHistory
                    moduleName={"custom_alert"}
                    revisionHistory={revisionHistory}
                    onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                />
            }
        </>
    )
}
export default RoleBaseAccess(CustomAlerts, { application: 'lease_revamp', feature: 'custom_alert', operationType: ['R'] });